import { Directive, OnInit } from '@angular/core';
import { Application } from '@modules/common/types/application';
import { StateKey } from '@modules/settings/types/state-key';
import { VirtualFolder } from '@modules/tasks/types/virtual-folder';
import { TasksContextMenuComponent } from '../components/tasks-context-menu/tasks-context-menu.component';
import { DPContextMenuDirective } from './dp-context-menu.directive';

@Directive({
  selector: '[appDPTasksContextMenu]',
  standalone: false,
})
export class TasksContextMenuDirective
  extends DPContextMenuDirective<VirtualFolder, TasksContextMenuComponent>
  implements OnInit
{
  protected override readonly application = Application.tasking;
  protected override readonly stateKey = StateKey.tasksDPSidebarFilters;

  protected override registerComponent() {
    return TasksContextMenuComponent;
  }
}
